/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import Field from 'components/grid/table/components/fields/field';
import { ColumnContainer } from 'components/grid/table/styled';
import Header from 'components/grid/table/components/column/components/header';
import { getPropsFromTypes } from 'utils/react';

const ActionsColumn = ({
  data,
  /*searchable,*/
  actionsElement,
  zIndex,
  ...props
}) => {
  const headerLabel = actionsElement?.props?.label;

  function getHeaderProps() {
    return getPropsFromTypes(
      {
        ...props,
        ...actionsElement.props,
      },
      // eslint-disable-next-line react/forbid-foreign-prop-types
      Header.propTypes,
    );
  }

  return (
    <ColumnContainer zIndex={zIndex} data-type="actions-column">
      {headerLabel && <Header {...getHeaderProps()} />}
      {data.map((rowData, rowNumber) => (
        <Field
          key={rowNumber}
          data={rowData}
          className={`row-${rowNumber}`}
          zIndex={data.length - rowNumber}
          rowNumber={rowNumber}>
          {({ data }) =>
            React.cloneElement(actionsElement, { data, rowNumber })
          }
        </Field>
      ))}
    </ColumnContainer>
  );
};

ActionsColumn.propTypes = {
  data: PropTypes.array.isRequired,
  searchable: PropTypes.bool.isRequired,
  actionsElement: PropTypes.node,
  zIndex: PropTypes.number,
};

ActionsColumn.defaultProps = {
  actionsElement: null,
  zIndex: undefined,
};

export default ActionsColumn;
